import { Component, OnInit, ViewChild, TemplateRef, SimpleChanges, HostListener, inject } from "@angular/core";
import { SidebarService, AppService, SessionService, NavbarService } from "../../services";

import { TranslateService, TranslateModule } from "@ngx-translate/core";

import * as _moment from "moment";
import { default as _rollupMoment, Moment } from "moment";
import { AppComponent } from '../../app.component';
import { AppStateHolder } from '../../shared';
import { CompanyProperty } from "../../properties";
import { DebugLoggerService } from '../../services/debug-logger.service';
import { RouterLink } from "@angular/router";
import { NgTemplateOutlet, AsyncPipe } from "@angular/common";
import { SidebarMobileComponent } from "../sidebar-mobile/sidebar-mobile.component";

const moment = _rollupMoment || _moment;

@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.css"],
    standalone: true,
    imports: [
        RouterLink,
        NgTemplateOutlet,
        SidebarMobileComponent,
        TranslateModule,
        AsyncPipe,
    ],
})
export class NavbarComponent implements OnInit {
  sidebarSrv = inject(SidebarService);
  appService = inject(AppService);
  private translate = inject(TranslateService);
  appComponent = inject(AppComponent);
  nvbService = inject(NavbarService);
  appStateHolder = inject(AppStateHolder);
  sessionSrv = inject(SessionService);
  cmpProperty = inject(CompanyProperty);
  private _debugLogger = inject(DebugLoggerService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  @ViewChild('GenericFilter') public GenericFilter: TemplateRef<any>;


  ngOnInit() {
    this._debugLogger.logLifecycle('Navbar', 'ngOnInit');
  }

  toggleMobileSidebar() {
    this._debugLogger.logAction('Navbar', 'toggleMobileSidebar');
    this.sidebarSrv.setToggleMobile(true);
  }
}
